import React from 'react';
import styles from './CSSZSickLeaveCertificateDetailItem.module.scss';
import Text from '../../../../Components/Base/Text/Text';
import FormattedMomentDate, {
	DateFormat,
} from '../../../Base/Components/FormattedMomentDate/FormattedMomentDate';

interface Props {
	title: string;
	value: React.ReactNode;
	bold?: boolean;
	formatDate?: boolean;
}

const CSSZSickLeaveCertificateDetailItem: React.FC<Props> = ({
	title,
	value,
	bold,
	formatDate,
}) => {
	let content: React.ReactNode = value;

	if (formatDate) {
		content = (
			<FormattedMomentDate date={value as string} format={DateFormat.DATE} />
		);
	}

	return (
		<div className={styles.wrapper}>
			<Text tx={title} className={styles.title} colon />
			<div className={bold ? styles.bold : ''}>{content}</div>
		</div>
	);
};

export default CSSZSickLeaveCertificateDetailItem;
